import { styled as o, Box as a, Typography as l } from "@mui/material";
import m from "../../assets/icon-info-invert.svg.js";
import { useAuthLibContext as c } from "../../contexts/AuthLibContext.js";
import x from "../../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import g from "../../../temp-lib/components/share/next/Image.js";
import { useTranslation as f, Trans as h } from "react-i18next";
import { jsxs as d, jsx as t } from "react/jsx-runtime";
const u = o(a)`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
`, k = o(g)`
  aspect-ratio: 1;
  margin-top: 2px;
  width: 16px;
`, y = o(l)`
  font-size: 12px;
`, e = o(x)`
  color: #3682eb;
  line-height: 14px;
  margin-bottom: 2px;
`, w = () => {
  var r;
  const {
    t: i
  } = f(), {
    config: n
  } = c(), {
    termsURL: s = "",
    privacyURL: p = ""
  } = ((r = n == null ? void 0 : n.login) == null ? void 0 : r.external) || {};
  return /* @__PURE__ */ d(u, {
    children: [/* @__PURE__ */ t(k, {
      src: m
    }), /* @__PURE__ */ t(y, {
      children: /* @__PURE__ */ t(h, {
        components: {
          lnk: /* @__PURE__ */ t(e, {
            url: s,
            target: "_blank"
          }),
          lnk2: /* @__PURE__ */ t(e, {
            url: p,
            target: "_blank"
          })
        },
        children: i("login.general.misc.hint")
      })
    })]
  });
};
export {
  w as default
};
//# sourceMappingURL=LoginAgreement.js.map
